import { createContext } from '@chakra-ui/react-utils';

interface ThinkingContext {
  isThinking: boolean;
  isExpanded: boolean;
  setIsExpanded: (value: boolean) => void;
  isToggleExpansionDisabled: boolean;
}

export const [ThinkingProvider, useThinkingContext] =
  createContext<ThinkingContext>({
    name: 'ThinkingContext',
    errorMessage:
      'useThinkingContext: `context` is undefined. Seems you used a Thinking sub-component outside of a Thinking wrapping box.',
  });
